import { create } from "zustand";

interface ImagePreviewStore {
  isOpen: boolean;
  imageUrl: string | null;
  altText: string;
  open: (imageUrl: string, altText: string) => void;
  close: () => void;
}

export const useImagePreviewStore = create<ImagePreviewStore>((set) => ({
  isOpen: false,
  imageUrl: null,
  altText: "",
  open: (imageUrl, altText) => set({ isOpen: true, imageUrl, altText }),
  close: () => set({ isOpen: false }),
}));
